import { useContext } from 'react';

import { XYChartLoadingContext } from '../context/XYChartLoading.context.js';

export const useXYChartLoading = () => {
  const context = useContext(XYChartLoadingContext);

  if (context === undefined) {
    throw new Error(
      'useXYChartLoading must be used within a XYChartLoadingContext',
    );
  }

  return context;
};
